import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserProfileStore = defineStore(
    'userProfile',
    () => {
        const userProfile = ref<{ fullName?: string } | null>(null)
        const isLoading = ref(false)
        const error = ref<Error | null>(null)
        const pictureUrl = computed(() => undefined as string | undefined)

        return {
            userProfile,
            isLoading,
            error,
            pictureUrl
        }
    }
)
